<template>
  <div class="cg-wrap">
    <div class="cg-brand"><h1>🚑 Help the ambulance find you</h1><div class="cg-sub" v-if="dispatch">{{ dispatch.caller_name || 'Hello' }} — drop your location below</div></div>
    <div v-if="error" class="cg-err">{{ error }}</div>
    <div v-if="dispatch">
      <div class="cg-card"><div class="muted">Tap <strong>Share my location</strong> or tap the map where the patient is. Drag the pin to fine-tune.</div></div>
      <div ref="map" class="cg-map"></div>
      <div style="height:14px;"></div>
      <button class="cg-btn" :disabled="busy" @click="share">{{ busy ? 'Sharing…' : '📍 Share my location' }}</button>
      <div v-if="result" :class="['cg-result', resultKind]"><span>{{ result }}</span></div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { executeJson, hms } from "@/api";
export default {
  name: "AmbulanceCallerGpsPublic",
  data() { return { dispatch: null, error: '', busy: false, result: '', resultKind: 'ok', _map: null, _marker: null }; },
  mounted() { this.load(); },
  beforeUnmount() { if (this._map) { try { this._map.remove(); } catch (e) {} } },
  methods: {
    async load() {
      var token = this.$route.params.token;
      if (!token || token.length !== 32) { this.error = 'Invalid link.'; return; }
      try {
        var r = await executeJson({ function: 'getCallerGpsContext', t: token }, hms);
        if (!r.data || !r.data.success) { this.error = (r.data && r.data.message) || 'Link not found.'; return; }
        this.dispatch = r.data.data.dispatch;
        this.$nextTick(() => this.initMap());
      } catch (e) { this.error = 'Could not connect.'; }
    },
    initMap() {
      if (typeof window.L === 'undefined') { setTimeout(() => this.initMap(), 400); return; }
      var L = window.L;
      var d = this.dispatch;
      var lat = d.pickup_lat != null ? Number(d.pickup_lat) : -1.2921;
      var lng = d.pickup_lng != null ? Number(d.pickup_lng) :  36.8219;
      this._map = L.map(this.$refs.map).setView([lat, lng], d.pickup_lat ? 16 : 11);
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19 }).addTo(this._map);
      this._marker = L.marker([lat, lng], { draggable: true }).addTo(this._map);
      this._map.on('click', (e) => this._marker.setLatLng(e.latlng));
    },
    share() {
      this.busy = true;
      if (!navigator.geolocation) {
        var ll = this._marker.getLatLng();
        this.send(ll.lat, ll.lng); return;
      }
      navigator.geolocation.getCurrentPosition(
        (pos) => { this._marker.setLatLng([pos.coords.latitude, pos.coords.longitude]); this._map.setView([pos.coords.latitude, pos.coords.longitude], 17); this.send(pos.coords.latitude, pos.coords.longitude, pos.coords.accuracy); },
        () => { var ll = this._marker.getLatLng(); this.send(ll.lat, ll.lng); },
        { enableHighAccuracy: true, timeout: 12000 }
      );
    },
    async send(lat, lng, acc) {
      var params = { function: 'submitCallerGps', t: this.$route.params.token, lat: lat, lng: lng };
      if (acc != null) params.accuracy_m = Math.round(acc);
      try {
        var r = await executeJson(params, hms);
        if (r.data && r.data.success) { this.result = '✓ Location shared. The dispatcher can see exactly where you are.'; this.resultKind = 'ok'; }
        else                          { this.result = (r.data && r.data.message) || 'Could not send.'; this.resultKind = 'bad'; }
      } catch (e) { this.result = 'Connection error.'; this.resultKind = 'bad'; }
      this.busy = false;
    }
  }
};
</script>

<style scoped>
.cg-wrap { max-width: 600px; margin: 0 auto; padding: 16px; background: #F4F6F9; min-height: 100vh; color: #1a1a1a; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif; }
.cg-brand { background: #dc3545; color: #fff; padding: 18px 22px; border-radius: 14px; margin-bottom: 14px; }
.cg-brand h1 { margin: 0; font-size: 18px; }
.cg-sub { font-size: 13px; opacity: 0.95; margin-top: 4px; }
.cg-card { background: #fff; border: 1px solid #E0E6ED; border-radius: 12px; padding: 16px; margin-bottom: 12px; }
.cg-map { width: 100%; height: 380px; border-radius: 12px; border: 1px solid #E0E6ED; overflow: hidden; }
.cg-btn { display: block; width: 100%; padding: 16px; font-size: 17px; font-weight: 700; border-radius: 12px; border: none; background: #0047AB; color: #fff; cursor: pointer; }
.cg-btn:disabled { background: #aaa; }
.cg-result { margin-top: 14px; padding: 14px; border-radius: 10px; }
.cg-result.ok  { background: rgba(40,167,69,.08); color: #28a745; border: 1px solid rgba(40,167,69,.3); }
.cg-result.bad { background: rgba(220,53,69,.08); color: #dc3545; border: 1px solid rgba(220,53,69,.3); }
.cg-err { background: rgba(220,53,69,.08); border: 1px solid rgba(220,53,69,.3); color: #dc3545; padding: 14px; border-radius: 10px; }
.muted { color: #777; font-size: 13px; line-height: 1.5; }
</style>
